import React, { useEffect, useRef } from 'react'

/** Common Components */
import FormCreator from '../../../../components/finalForms/FormCreator';

/** Common Services & Data Files */
import ToastService from '../../../../services/toastService/ToastService';

/** Configuration Files */
import { attachmentForm } from './config/Attachments.data';

/** RTK Query */
import { useAddTaskAttachmentMutation } from '../../../../app/services/taskattachmentAPI';

const AddAttachments = ({ onClose, taskId, projectId }) => {

  const fileref = useRef();

  const [addTaskAttachment, {
    isSuccess: isaddTaskAttachmentAdded,
    isLoading: isTaskAttachmentAdding,
    data: addTaskAttachmentData
  },] = useAddTaskAttachmentMutation();


  const handleFileFieldBlur = (dataField, updatedValue) => {

    const fileAttachment = updatedValue?.[dataField];

    if (fileAttachment) {
      let request = {
        attachmentPath: fileAttachment[0].fileName,
        attachmentType: fileAttachment[0].file.type,
        base64File: fileAttachment[0].base64Data,
        taskId: taskId,
        projectId: projectId
      };
      addTaskAttachment(request);
    };
  }

  useEffect(() => {
    if (isaddTaskAttachmentAdded && addTaskAttachmentData) {
      if (addTaskAttachmentData.errorMessage.includes("exists")) {
        ToastService.warning(addTaskAttachmentData.errorMessage);
        return;
      } else {
        ToastService.success(addTaskAttachmentData.errorMessage);
        onClose();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isaddTaskAttachmentAdded, addTaskAttachmentData]);

  return (
    <FormCreator
      config={attachmentForm}
      ref={fileref}
      onFieldBlure={handleFileFieldBlur}
      isLoading={isTaskAttachmentAdding}
    />

  )
}

export default AddAttachments;